import { render, staticRenderFns } from "./group-tip-element.vue?vue&type=template&id=2344c6ec&scoped=true&"
import script from "./group-tip-element.vue?vue&type=script&lang=js&"
export * from "./group-tip-element.vue?vue&type=script&lang=js&"
import style0 from "./group-tip-element.vue?vue&type=style&index=0&id=2344c6ec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2344c6ec",
  null
  
)

export default component.exports